import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const markPayoutPaid = {
  name: "markPayoutPaid" as const,
  input: z.object({ payoutId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
